const Host = {
  demo: '//demo.api.starworldgames.com',
  production: '//api.starworldgames.com',
};

export default Host;
